/**
 * Dynamic transformers loading (Cleros-style approach)
 */

// Global availability flag and model paths
declare global {
  interface Window {
    __EMBEDDINGS_AVAILABLE__: boolean;
    __EMBEDDINGS_UNAVAILABLE__: boolean;
    __MODEL_PATHS__: Record<string, string>;
  }
}

// Dynamic import cache
let transformersModule: any = null;

export async function loadTransformers() {
  if (!transformersModule) {
    console.log('🔮 Loading transformers module...');
    try {
      transformersModule = await import('@xenova/transformers');

      // Configure transformers.js after loading
      const { env } = transformersModule;

      // Detect if running in Node.js vs Browser
      const isNode = typeof window === 'undefined';

      if (isNode) {
        // Node.js configuration - allow remote downloads
        env.useBrowserCache = false;
        env.allowLocalModels = true;
        env.allowRemoteModels = true;
        env.cacheDir = './.cache';
      } else {
        // Browser configuration - use local models served as static assets
        env.useBrowserCache = true;
        env.allowLocalModels = true;
        env.allowRemoteModels = false;
        env.localModelPath = '/models/';
        env.cacheDir = './.cache';

        // Additional configuration for proper asset loading
        env.backends = {
          onnx: {
            wasm: {
              wasmPaths: '/assets/',
            },
          },
        };
      }

      // Set availability flag (only in browser)
      if (typeof window !== 'undefined') {
        window.__EMBEDDINGS_AVAILABLE__ = true;
        window.__EMBEDDINGS_UNAVAILABLE__ = false;
      }

      console.log('✅ Transformers module loaded successfully');
    } catch (error) {
      console.error('❌ Failed to load transformers:', error);

      // Set failure flags but don't crash (only in browser)
      if (typeof window !== 'undefined') {
        window.__EMBEDDINGS_AVAILABLE__ = false;
        window.__EMBEDDINGS_UNAVAILABLE__ = true;
      }

      throw error;
    }
  }
  return transformersModule;
}

// Export pipeline with graceful error handling
export const pipeline = async (...args: any[]) => {
  try {
    const t = await loadTransformers();
    return await t.pipeline(...args);
  } catch (error) {
    console.error('Pipeline creation failed:', error);
    throw error;
  }
};
